
"use client"

import * as React from "react"
import { Sun, Moon } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { useIsMobile } from "@/hooks/use-mobile"
import { useTheme } from "@/hooks/useTheme"

export function ModeToggle() {
  const isMobile = useIsMobile()
  const { theme, setTheme, toggleTheme, isLoading } = useTheme()

  if (isLoading) {
    return (
      <Button variant="ghost" size="icon" className="rounded-md border border-border">
        <Moon className="h-4 w-4" />
      </Button>
    )
  }

  const borderClass = theme === "dark" ? "border border-gray-500" : "border border-border"

  // Mobile toggle button version
  if (isMobile) {
    return (
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button 
              variant="ghost" 
              size="icon"
              className={`rounded-md ${borderClass}`}
              onClick={toggleTheme}
            >
              {theme === "light" ? (
                <Moon className="h-4 w-4" />
              ) : (
                <Sun className="h-4 w-4" />
              )}
            </Button>
          </TooltipTrigger>
          <TooltipContent side="bottom">
            <p>Toggle theme</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  // Desktop version with two buttons
  return (
    <div className={`flex items-center rounded-md overflow-hidden ${borderClass}`}>
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className={`rounded-none ${theme === "light" ? "selected-theme" : ""}`}
              onClick={() => setTheme("light")}
            >
              <Sun className={`h-4 w-4 ${
                theme === "light" 
                  ? "" 
                  : "text-gray-500 dark:text-white"
              }`} />
              <span className="sr-only">Light mode</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent side="bottom">
            <p>Light mode</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className={`rounded-none ${theme === "dark" ? "selected-theme" : ""}`}
              onClick={() => setTheme("dark")}
            >
              <Moon className={`h-4 w-4 ${
                theme === "dark" 
                  ? "" 
                  : "text-gray-500 dark:text-white"
              }`} />
              <span className="sr-only">Dark mode</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent side="bottom">
            <p>Dark mode</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  )
}
